var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistrationFail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.417 0.75C16.4297 0.750176 17.2498 1.57035 17.25 2.58301V15.417C17.2498 16.4297 16.4297 17.2498 15.417 17.25H2.58301C1.57035 17.2498 0.750176 16.4297 0.75 15.417V2.58301C0.750176 1.57035 1.57035 0.750176 2.58301 0.75H15.417ZM9 7.74219L5.85742 4.59961L4.59961 5.85645L7.74219 8.99902L4.60156 12.1416L5.8584 13.3984L9 10.2568L12.1416 13.3984L13.3984 12.1416L10.2568 8.99902L13.4004 5.85645L12.1426 4.59961L9 7.74219Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationFail);
export default __webpack_public_path__ + "static/media/RegistrationFail.330d81980b8a5ad40121c37458110567.svg";
export { ForwardRef as ReactComponent };